/* eslint-disable max-len */
import React, { useState } from 'react';
import Buttons from '../../components/Buttons';
import DashboardWrap from '../../components/DashboardWrap';
import PlusIcon from '../../svgs/PlusIcon';
import PartnerCouponsDashboard from './PartnerCouponsDashboard';
import PartnerCouponsRecord from './PartnerCouponsRecord';
import Styles from './PartnerCoupons.module.scss';

const PartnerCoupons = () => {
  const [isShowCreateModal, setIsShowCreateModal] = useState(false);
  const [statsRefreshKey, setStatsRefreshKey] = useState(0);

  const bumpStats = () => setStatsRefreshKey((n) => n + 1);

  return (
    <DashboardWrap>
      <div className={Styles.wrapper}>
        <div className={Styles.wrapper__header}>
          <div>
            <div className={Styles.wrapper__title}>Partner Coupons</div>
          </div>
          <div className={Styles.wrapper__buttonContainer}>
            <Buttons
              name="Create coupon"
              Icon={PlusIcon}
              onClick={() => setIsShowCreateModal(true)}
            />
          </div>
        </div>
        <PartnerCouponsDashboard refreshKey={statsRefreshKey} />
        <PartnerCouponsRecord
          isShowCreateModal={isShowCreateModal}
          setIsShowCreateModal={setIsShowCreateModal}
          onCouponsMutated={bumpStats}
        />
      </div>
    </DashboardWrap>
  );
};

export default PartnerCoupons;
